var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.86,
    height: 22.86,
    viewBox: "0 0 22.86 22.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24346",
    "data-name": "Path 24346",
    d: "M1163.623,994.686a.372.372,0,0,0-.419.422v9a.372.372,0,0,0,.419.422h8.944a.372.372,0,0,0,.419-.422,9.254,9.254,0,0,0-2.376-6.188A8.935,8.935,0,0,0,1163.623,994.686Zm.419,9V995.67a8.371,8.371,0,0,1,7.966,8.016Zm6.708,3.234a.372.372,0,0,0-.419-.422h-9.224v-9.281a.372.372,0,0,0-.419-.422,10.125,10.125,0,1,0,10.062,10.125Zm-10.062,9.281a9.288,9.288,0,0,1-.419-18.563v9.282a.372.372,0,0,0,.419.422h9.224A9.349,9.349,0,0,1,1160.688,1016.2Z",
    transform: "translate(-1150.376 -994.436)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.80c170a2543f366b369e23030655b068.svg";
export { ForwardRef as ReactComponent };